'use client';
import React from 'react';
import { ContentType } from '@/constants/content.constants';
import { useGetAppContent } from '@/hooks/User/queries';
import { Spin } from 'antd';

const TermsPage = () => {
  const { data, isLoading } = useGetAppContent(
    ContentType.TERMS_AND_CONDITIONS,
  );

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Spin />
      </div>
    );
  }

  return (
    <>
      <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">
        Terms and Conditions
      </h1>

      <div
        className="terms-content  prose prose-lg max-w-none prose-headings:text-gray-800 prose-headings:font-semibold prose-p:text-gray-600 prose-p:leading-relaxed prose-li:text-gray-600 prose-a:text-primary"
        dangerouslySetInnerHTML={{
          __html: data?.translations?.en?.content as string,
        }}
      />
    </>
  );
};

export default TermsPage;
